export const bedTypes = ["Single", "Twin", "Twin XL", "Double", "Full", "Queen", "King", "California King"];
